import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {PatchValue} from "./patch-value";

export const AddressCodec = t.intersection([
  t.type({}),
  t.partial({
    street: t.string,
    street2: t.string,
    city: t.string,
    county: t.string,
    state: t.string,
    postalCode: t.string,
    country: t.string,
    province: t.string,
  }),
]);

export const AddressArrayValidator = t.array(AddressCodec);

export type Address = t.TypeOf<typeof AddressCodec>;
export type AddressArray = t.TypeOf<typeof AddressArrayValidator>;

@Exclude()
export class AddressEntity {
  @Expose() street?: string
  @Expose() street2?: string
  @Expose() city?: string
  @Expose() county?: string
  @Expose() state?: string
  @Expose() postalCode?: string
  @Expose() country?: string
  @Expose() province?: string

  /**
   * Constructor for AddressEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(containerFill: Address): AddressEntity {
    return plainToInstance(
      AddressEntity,
      containerFill,
      {
        excludeExtraneousValues: true,
      }
    );
  }

  loadTypeValue(): Promise<Address> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(AddressCodec, object);
  }

  asTypeValue(): Address {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(AddressCodec, object);
  }

  get isEmpty() : boolean {
    return !this.street && !this.street2 && !this.city && !this.county && !this.state && !this.postalCode && !this.country && !this.province;
  }
}

export interface AddressPatchDTO {
  street?: PatchValue<string>
  street2?: PatchValue<string>
  city?: PatchValue<string>
  county?: PatchValue<string>
  state?: PatchValue<string>
  postalCode?: PatchValue<string>
  country?: PatchValue<string>
  province?: PatchValue<string>
}
